import React from 'react';
import { Grid, Card, CardContent, Skeleton, Box, Paper } from '@mui/material';

// 1. Dashboard Card Skeleton
export const DashboardSkeleton = () => (
    <Grid container spacing={3} sx={{ mb: 3 }}>
        {[1, 2, 3, 4].map((i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
                <Card sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
                    <Skeleton variant="circular" width={64} height={64} sx={{ mr: 2 }} />
                    <Box sx={{ width: '100%' }}>
                        <Skeleton variant="text" width="60%" />
                        <Skeleton variant="text" width="40%" height={40} />
                    </Box>
                </Card>
            </Grid>
        ))}
    </Grid>
);

// 2. Data Grid / Table Skeleton
export const TableSkeleton = () => (
    <Paper sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <Skeleton variant="rectangular" width={200} height={40} />
            <Skeleton variant="rectangular" width={200} height={40} />
            <Skeleton variant="rectangular" width={100} height={40} sx={{ ml: 'auto' }} />
        </Box>
        {[1, 2, 3, 4, 5].map((i) => (
            <Box key={i} sx={{ display: 'flex', gap: 2, my: 2 }}>
                <Skeleton variant="rectangular" width="100%" height={50} />
            </Box>
        ))}
    </Paper>
);

// 3. Profile/Form Skeleton
export const FormSkeleton = () => (
    <Paper sx={{ p: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <Skeleton variant="circular" width={120} height={120} />
        </Box>
        <Grid container spacing={3}>
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <Grid item xs={12} sm={6} key={i}>
                    <Skeleton variant="text" width="30%" />
                    <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                </Grid>
            ))}
        </Grid>
    </Paper>
);

// 4. Chart Skeleton
export const ChartSkeleton = () => (
    <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
            <Skeleton variant="rectangular" height={350} sx={{ borderRadius: 2 }} />
        </Grid>
        <Grid item xs={12} md={4}>
            <Skeleton variant="rectangular" height={350} sx={{ borderRadius: 2 }} />
        </Grid>
    </Grid>
);